import { createAction, props } from "@ngrx/store";
import { Withholding } from "../../models/withholding";

export const findWithholdingCatalogAct = createAction('findWithholdingCatalogEffect', props <{ id: number }>());
export const loadWithholdingCatalogByIdAct = createAction('loadWithholdingCatalogByIdEffect', props<{ withholding: Withholding }>());

export const resetWithholdingCatalogAct = createAction('resetWithholdingCatalogEffect');

export const updateWithholdingCatalogAct = createAction('updateWithholdingCatalogEffect', props<{ withholdingUpdated: Withholding }>());
export const updateSuccessWithholdingCatalogAct = createAction('updateSuccessWithholdingCatalogEffect', props<{ withholdingUpdated: Withholding }>());

export const saveWithholdingCatalogAct = createAction('saveWithholdingCatalogEffect', props<{ withholdingNew: Withholding }>());
export const saveSuccessWithholdingCatalogAct = createAction('saveSuccessWithholdingCatalogEffect', props<{ withholdingNew: Withholding }>());

export const setViolationsWithholdingCatalogAct = createAction('setViolationsWithholdingCatalogEffect', props<{ withholdingForm: Withholding, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
